module.exports = __webpack_public_path__ + "img/home_product.08419e5d.png";